"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.to-string.js");
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _customerRank = require("@/api/customer-rank");
var _index = _interopRequireDefault(require("@/components/Tinymce/index.vue"));
var RankModal = /*#__PURE__*/function (_Vue) {
  function RankModal() {
    var _this;
    (0, _classCallCheck2.default)(this, RankModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, RankModal, [].concat(args));
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "form", {
      description: ""
    });
    (0, _defineProperty2.default)(_this, "status", "create");
    (0, _defineProperty2.default)(_this, "loadingButton", false);
    (0, _defineProperty2.default)(_this, "staffs", []);
    (0, _defineProperty2.default)(_this, "rules", {
      name: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      },
      phone: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      }
    });
    (0, _defineProperty2.default)(_this, "isMountedEditor", false);
    return _this;
  }
  (0, _inherits2.default)(RankModal, _Vue);
  return (0, _createClass2.default)(RankModal, [{
    key: "created",
    value: function created() {}
  }, {
    key: "setDescription",
    value: function setDescription() {
      this.isMountedEditor = true;
      this.$refs.editor.setContent(this.form.description);
    }
  }, {
    key: "createData",
    value: function () {
      var _createData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _this2 = this;
        var valid, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$refs.form.validate();
            case 2:
              valid = _context.sent;
              data = {
                customerRank: this.form
              };
              this.loadingButton = true;
              _customerRank.customerRankApi.create(data).then(function (res) {
                if (res.status) {
                  _this2.$notify.success({
                    title: "Create rank",
                    message: "Successfully"
                  });
                  _this2.visible = false;
                  _this2.$emit("submit:success");
                }
              }).finally(function () {
                _this2.loadingButton = false;
              });
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createData() {
        return _createData.apply(this, arguments);
      }
      return createData;
    }()
  }, {
    key: "handleDelete",
    value: function () {
      var _handleDelete = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return this.$confirm("Confirm delete this souce?", "Warning", {
                cancelButtonText: "No",
                confirmButtonText: "Delete",
                type: "warning"
              });
            case 3:
              this.loadingButton = true;
              _context2.next = 6;
              return _customerRank.customerRankApi.delete(this.form.id);
            case 6:
              this.$notify.success({
                title: "Delete souce",
                message: "Successfully"
              });
              this.visible = false;
              this.$emit("submit:success");
            case 9:
              _context2.prev = 9;
              this.loadingButton = false;
              return _context2.finish(9);
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0,, 9, 12]]);
      }));
      function handleDelete() {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }()
  }, {
    key: "updateData",
    value: function () {
      var _updateData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var _this3 = this;
        var valid, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.$refs.form.validate();
            case 2:
              valid = _context3.sent;
              data = {
                customerRank: this.form
              };
              this.loadingButton = true;
              _customerRank.customerRankApi.update(this.form.id, data).then(function (res) {
                if (res.status) {
                  _this3.$notify.success({
                    title: "Update rank",
                    message: "Successfully"
                  });
                  _this3.visible = false;
                  _this3.$emit("submit:success");
                }
              }).finally(function () {
                _this3.loadingButton = false;
              });
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      var _this4 = this;
      this.visible = true;
      this.status = "create";
      this.form = {
        description: ""
      };
      this.$nextTick(function () {
        _this4.$refs["form"].clearValidate();
        if (_this4.isMountedEditor) {
          _this4.$refs["editor"].setContent("");
        }
      });
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(data) {
      var _this5 = this;
      this.form = (0, _objectSpread2.default)({}, data);
      this.status = "update";
      this.visible = true;
      this.$nextTick(function () {
        _this5.$refs["form"].clearValidate();
        if (_this5.isMountedEditor) {
          _this5.$refs["editor"].setContent(data.description);
        }
      });
    }
  }]);
}(_vuePropertyDecorator.Vue);
RankModal = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    Tinymce: _index.default
  }
})], RankModal);
var _default = exports.default = RankModal;